import { Skeleton } from "@mui/material";
import { TableSkeletonRow } from "../StyledTable.styles.ts";

const TableSkeleton = () => {
	return (
		<>
			{[...Array(10)].map((index) => (
				<TableSkeletonRow key={index}>
					<Skeleton height={43} />
					<Skeleton height={43} />
					<Skeleton height={43} />
					<Skeleton height={43} />
					<Skeleton height={43} />
					<div>
						<Skeleton height={17} />
						<Skeleton height={17} />
					</div>
				</TableSkeletonRow>
			))}
		</>
	);
};

export default TableSkeleton;
